import { useEffect, useMemo, useRef, useState } from 'react';
import './newCurHome.scss';
import Navigations from '../../components/navigations/navigations';
import HeaderInfor from '../../components/headerInfor/newcurHeaderInfo';
import { getCookieAmend, setCookie, getCookie, delCookie } from '../../util/cookie';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import NewContent from '../newContent/newCurContent';
import { useCustomTranslation } from '@/hooks/useCustomTranslation';
import Marquee from '../../components/marquee/marquee';
import { keycodeHandle, debounce, AstroSaveCookie } from '../../util/util';
import Event, { EVENTS } from '../../util/event';
import { getHomePageData, getNavigations, removeNavigations } from './getData';
import { useDidCache, useDidRecover } from 'react-router-cache-route';
import If from '../../components/if/if';
import Mine from '../mine/mine';
import { $tv } from 'react-tv-focusable';
import { report } from '../../util/dataReporting';

let headerGetMsgTimer = null;
let keyCodeInitTimer = null;
export default function NewHome() {
  // 多语言
  const { t } = useCustomTranslation();
  // 跳转函数
  const jumpHistory = useHistory();
  // 当前选中的channelId信息
  const [curChannelId, setCurChannelId] = useState('');
  // 渠道号
  const [vChannelId, setVChannelId] = useState('');
  // navigation数组 Navigator组件值
  // const [navigations, setNavigations] = useState([]);
  // 1头部，2导航栏，3poster，4history，5columnAboveFilter，6filter，7columnUnderFilter，8footer，9mine页面
  const [headerflag, setHeaderflag] = useState(2);
  const headerflagRef = useRef(2);
  useEffect(() => {
    headerflagRef.current = headerflag;
  }, [headerflag]);
  // 是否拿不到数据(用于页面展示)
  const [isNoData, setIsNoData] = useState('');
  // 是否拿不到数据(用于判断条件进行逻辑处理)
  const isNoDataRef = useRef(false);
  // 是否正在获取数据
  const [isGetData, setIsGetData] = useState(false);
  const isGetDataRef = useRef(isGetData);
  useEffect(() => {
    isGetDataRef.current = isGetData;
  }, [isGetData]);
  // 路由缓存是否跳出该页面
  const [isLeave, setIsLeave] = useState(false);
  // 路由缓存是否跳出该页面ref值
  const isLeaveRef = useRef(false);
  // 是否有海报信息
  const [isHavePoster, setIsHavePoster] = useState(false);
  // 是否有历史记录信息
  const [isHaveHistory, setIsHaveHistory] = useState(false);
  // 是否有下方的column分页数据模块
  const [isHaveColumn, setIsHaveColumn] = useState(false);
  // 是否有第一个column模块
  const [isHaveFirstColumn, setIsHaveFirstColumn] = useState(false);
  // 是否是MineTab
  const [isMineTab, setIsMineTab] = useState(false);
  // 会员结束时间?
  const [end, setEnd] = useState('');
  // 用户身份，游客、非会员、会员
  const [status, setStatus] = useState('');
  const [moreTabJumpLink, setMoreTabJumpLink] = useState('');
  // 是否要重新更新数据
  const [isUpdateData, setIsUpdateData] = useState(false);
  // 主页停留时间
  const stayTime = useRef(0);
  // 当前展示的navigation
  const [curNavigation, setCurNavigation] = useState({});
  // 是否是第一次进入页面
  const isFirstEnter = useRef(true);
  useEffect(() => {
    const curNavigation = getNavigations(curChannelId);
    setCurNavigation((navigationInfo) => {
      if (!navigationInfo?.navigation) {
        return curNavigation;
      }
      return {
        ...curNavigation,
        navigation: navigationInfo?.navigation,
      };
    });
  }, [curChannelId]);

  useEffect(() => {
    const curNavigation = getNavigations(curChannelId);
    setCurNavigation(curNavigation || {});
  }, [isUpdateData]);

  const temporaryBoxRef = useRef(null);

  // 是否有filter模块
  const isHaveFilter = useMemo(() => {
    const firstCategory = curNavigation?.curNav?.channel?.user_choice?.first_category;
    return firstCategory
      && firstCategory !== 'All'
      && curNavigation?.poster?.posterArr?.length
      && curNavigation?.column?.length;
  }, [curNavigation]);

  // 是否有navigation
  const [isHaveNavigation, setIsHaveNavigation] = useState(false);
  const isHaveNavigationRef = useRef(false);
  useEffect(() => {
    setIsHaveNavigation(!!curNavigation.navigation?.length);
    isHaveNavigationRef.current = !!curNavigation.navigation?.length;
  }, [curNavigation.navigation]);

  const nextPageData = useMemo(() => ({
    channelId: curNavigation?.channelId,
    pageCtx: curNavigation?.pageCtx,
    hasNextPage: curNavigation?.hasNextPage,
  }), [curNavigation]);

  const temporaryBoxMove = () => {
    $tv.requestFocus(temporaryBoxRef.current);
  };

  const temporaryBoxAddEvent = () => {
    temporaryBoxRef.current.addEventListener('up', temporaryBoxMove);
    temporaryBoxRef.current.addEventListener('down', temporaryBoxMove);
    temporaryBoxRef.current.addEventListener('left', temporaryBoxMove);
    temporaryBoxRef.current.addEventListener('right', temporaryBoxMove);
  };

  const temporaryBoxRemoveEvent = () => {
    try {
      temporaryBoxRef.current.removeEventListener('up', temporaryBoxMove);
      temporaryBoxRef.current.removeEventListener('down', temporaryBoxMove);
      temporaryBoxRef.current.removeEventListener('left', temporaryBoxMove);
      temporaryBoxRef.current.removeEventListener('right', temporaryBoxMove);
    } catch (_e) {
    }
  };

  const keyCodeAdd = () => {
    keycodeHandle({
      exit: keyDownExit,
      quit: keyDownExit,
      up: keyDownUp,
      down: keyDownDown,
      left: keyDownLeft,
      right: keyDownRight,
      click: keyDownClick,
    });
  };

  const keyCodeRemove = () => {
    keycodeHandle({});
  };

  // 交互事件处理函数
  const keyDownExit = debounce(() => {
    if (isGetDataRef.current || isLeaveRef.current) return;
    $tv.requestFocus(temporaryBoxRef.current);
    Event.emit(EVENTS.HOME_PAGE_KEY_DOWN_EXIT);
  }, 100);
  const keyDownUp = debounce(() => {
    if (isGetDataRef.current || isLeaveRef.current) return;
    if (headerflagRef.current === 1) {
      Event.emit(EVENTS.HEADER_INFO_KEY_DOWN_UP);
      return;
    };
    Event.emit(EVENTS.HOME_PAGE_KEY_DOWN_UP);
  }, 100);
  const keyDownDown = debounce(() => {
    if (isGetDataRef.current || isLeaveRef.current) return;
    if (headerflagRef.current === 1) {
      Event.emit(EVENTS.HEADER_INFO_KEY_DOWN_DOWN);
      return;
    };
    Event.emit(EVENTS.HOME_PAGE_KEY_DOWN_DOWN);
  }, 100);
  const keyDownLeft = debounce(() => {
    if (isGetDataRef.current || isLeaveRef.current) return;
    if (headerflagRef.current === 1) {
      Event.emit(EVENTS.HEADER_INFO_KEY_DOWN_LEFT);
      return;
    };
    Event.emit(EVENTS.HOME_PAGE_KEY_DOWN_LEFT);
  }, 100);
  const keyDownRight = debounce(() => {
    if (isGetDataRef.current || isLeaveRef.current) return;
    if (headerflagRef.current === 1) {
      Event.emit(EVENTS.HEADER_INFO_KEY_DOWN_RIGHT);
      return;
    };
    Event.emit(EVENTS.HOME_PAGE_KEY_DOWN_RIGHT);
  }, 100);
  const keyDownClick = debounce(() => {
    if (isGetDataRef.current || isLeaveRef.current) return;
    if (headerflagRef.current === 1) {
      Event.emit(EVENTS.HEADER_INFO_KEY_DOWN_CLICK);
      return;
    };
    Event.emit(EVENTS.HOME_PAGE_KEY_DOWN_CLICK);
  }, 100);

  function headerDown() {
    if (isHaveNavigationRef.current) {
      setHeaderflag(2);
      return;
    }
    if (isNoDataRef.current) return;
    setHeaderflag(8);
  }

  const getHomePage = async (isChangeLanguage) => {
    setIsGetData(true);
    setIsNoData('');
    isNoDataRef.current = false;
    const result = await getHomePageData({
      firstGet: true,
      channelId: '',
      pageCtx: '',
    });
    AstroSaveCookie();
    if (result === null) {
      setIsNoData('暂无相关内容');
      isNoDataRef.current = true;
      setCurChannelId('');
      setHeaderflag(1);
    } else {
      setCurChannelId(result);
      if (!isChangeLanguage) {
        setHeaderflag(2);
      }
    }
    setIsGetData(false);
    getStatus();
    if (!isLeaveRef.current) {
      keyCodeAdd();
    }
    if (isChangeLanguage) {
      setIsUpdateData(isUpdateData => !isUpdateData);
    }
  };

  // 切换频道
  const changeChannel = async (event) => {
    const { isMine, channelId } = event;
    try {
      setIsGetData(true);
      setIsNoData('');
      isNoDataRef.current = false;

      if (isMine) {
        setIsMineTab(true);
      } else {
        setIsMineTab(false);
        const result = await getHomePageData({
          firstGet: false,
          channelId,
          pageCtx: '',
        });
        getStatus();

        if (result === null) {
          setIsNoData('服务异常，请稍后重试');
          isNoDataRef.current = true;
          setCurChannelId(channelId);
          setHeaderflag(1);
        } else {
          setCurChannelId(result);
        }
      }
    } catch (error) {
      // 处理任何可能的错误
      setIsNoData('服务异常，请稍后重试');
      isNoDataRef.current = true;
      setCurChannelId(channelId);
      setHeaderflag(1);
    } finally {
      // 确保无论如何都会重置加载状态
      setIsGetData(false);
    }
  };

  function updateState(data) {
    if (data.headerflag !== 8) {
      $tv.requestFocus(temporaryBoxRef.current);
    }
    setHeaderflag(data.headerflag);
  };

  const languageChange = () => {
    removeNavigations();
    getHomePage(true);
  };

  const enterHomePageReport = () => {
    stayTime.current = new Date().getTime();
    setCookie('page_id', 'linuxtv_homepage'); // 首页当前页面的id
    // 首页进入上报
    report({
      attaId: '0cb00063509',
    });
  };

  const leaveHomePageReport = () => {
    const time = new Date().getTime() - stayTime.current;
    // 首页离开上报
    report({
      attaId: '0cb00063509',
      staytime: time,
    });
    setCookie('ref_page', 'linuxtv_homepage'); // 首页当前页面的上个页面id
  };

  const enterHomePageInit = () => {
    // 设置渠道号
    setVChannelId(localStorage.getItem('v_channel_id') || '');
    // 应入进入上报,移动到index.js中了
    // appLaunchReport();
    // 刚进页面时页面位于顶部
    window.scrollTo(0, 0);
  };

  const HeaderGetMsg = () => {
    if (getCookie('focalMemory')) {
      delCookie('focalMemory');
    }
    $tv.requestFocus(temporaryBoxRef.current);
    if (headerGetMsgTimer) {
      clearTimeout(headerGetMsgTimer);
      headerGetMsgTimer = null;
    }
    headerGetMsgTimer = setTimeout(() => {
      setHeaderflag(2);
      clearTimeout(headerGetMsgTimer);
      headerGetMsgTimer = null;
    }, 150);
  };

  useEffect(() => {
    enterHomePageInit();
    setHeaderflag(1);
    getHomePage();
    temporaryBoxAddEvent();
    Event.on(EVENTS.HOME_UPDATE_STATE, updateState);
    Event.on(EVENTS.LANGUAGE_CHANGE, languageChange);
    Event.on(EVENTS.HOME_PAGE_CHANGE_CHANNEL, changeChannel);
    isFirstEnter.current = false;
    enterHomePageReport();
    return () => {
      leaveHomePageReport();
      keyCodeRemove();
      temporaryBoxRemoveEvent();
      clearTimeout(headerGetMsgTimer);
      headerGetMsgTimer = null;
      clearTimeout(keyCodeInitTimer);
      keyCodeInitTimer = null;
      Event.off(EVENTS.HOME_UPDATE_STATE, updateState);
      Event.off(EVENTS.LANGUAGE_CHANGE, languageChange);
      Event.off(EVENTS.HOME_PAGE_CHANGE_CHANNEL, changeChannel);
    };
  }, []);

  useDidCache(() => {
    isLeaveRef.current = true;
    leaveHomePageReport();
    clearTimeout(headerGetMsgTimer);
    headerGetMsgTimer = null;
    clearTimeout(keyCodeInitTimer);
    keyCodeInitTimer = null;
    isLeaveRef.current = true;
    setIsLeave(true);
    keyCodeRemove();
  });

  useDidRecover(() => {
    if (!isFirstEnter.current) {
      if (isNoDataRef.current) {
        getHomePage();
      }
      isFirstEnter.current = false;
      isLeaveRef.current = false;
      getStatus();
      keyCodeAdd();
      $tv.requestFocus(temporaryBoxRef.current);
      if (keyCodeInitTimer) {
        clearTimeout(keyCodeInitTimer);
        keyCodeInitTimer = null;
      }
      keyCodeInitTimer = setTimeout(() => {
        isLeaveRef.current = false;
        setIsLeave(false);
        clearTimeout(keyCodeInitTimer);
        keyCodeInitTimer = null;
      }, 50);
      enterHomePageReport();
    }
  });


  const getStatus = () => {
    if (getCookieAmend('isLogin')) {
      if (getCookieAmend('status')) {
        const status = getCookieAmend('status');
        const end = getCookieAmend('end');
        setEnd(end);
        setStatus(status);
      } else {
        setEnd('');
        setStatus('');
      }
    }
  };

  function filterWheel(e) {
    if (e.deltaY > 0) {
      keyDownDown();
    } else {
      keyDownUp();
    }
  }


  return (
    <div className='main' onWheel={e => filterWheel(e)}>
      <div
        className='temporaryBox'
        style={{ position: 'absolute', top: '0px', left: '0px', width: '100%', height: '500px', backgroundSize: 'cover', zIndex: '-1' }}
        focusable
        ref={temporaryBoxRef}
      >
      </div>
      {
        !isLeave ? (
          <HeaderInfor
            headerflag={headerflag}
            sourcePage={'home'}
            headerDown={headerDown}
          />
        ) : (<></>)
      }
      <If condition={!!isNoData && !isGetData}>
        <div className='noData__panel' >
          <span>
            {t(isNoData)}
          </span>
        </div>
      </If>
      <If condition={!!isGetData}>
        <div className='languageChangeLoading'>
          <div className='languageChangeLoading__icon'>
          </div>
        </div>
      </If>
      <Navigations
        navigations={curNavigation?.navigation}
        vChannelId={vChannelId}
        headerflag={headerflag}
        setHeaderflag={setHeaderflag}
        setMoreTabJumpLink={setMoreTabJumpLink}
        isMineTab={isMineTab}
        isLeave={isLeave}
        judgeCondition={{
          isHavePoster,
          isHaveHistory,
          isHaveFirstColumn,
          // 是否有filter组件
          isHaveFilter,
          isHaveColumn,
        }}
      >
      </Navigations>
      <If condition={isMineTab}>
        {
          !isLeave ? (
            <div style={{ display: isGetData || isNoData ? 'none' : 'block' }}>
              <Mine
                headerflag={headerflag === 8 ? 2 : 1}
                status={status}
                end={end}
                getMsg={HeaderGetMsg}
                history={jumpHistory}
              >
              </Mine>
            </div>
          )
            : (
              <></>
            )
        }
      </If>
      <If condition={!isMineTab}>
        <NewContent
          // 当前tab栏下的数据，包括poster，history，column等
          curNavigation={curNavigation}
          headerflag={headerflag}
          moreTabJumpLink={moreTabJumpLink}
          setHeaderflag={setHeaderflag}
          isLeave={isLeave}
          judgeCondition={{
            isHavePoster,
            isHaveHistory,
            isHaveFirstColumn,
            isHaveNavigation,
            // 是否有filter组件
            isHaveFilter,
            isHaveColumn,
            setIsHavePoster,
            setIsHaveHistory,
            setIsHaveFirstColumn,
            setIsHaveColumn,
          }}
          nextPageData={nextPageData}
          isGetData={isGetData}
          isNoData={isNoData}
        >
        </NewContent>
        <Footer
          headerflag={headerflag}
          isLeave={isLeave}
          judgeCondition={{
            isHavePoster,
            isHaveHistory,
            isHaveFirstColumn,
            // 是否有filter组件
            isHaveFilter,
            isHaveColumn,
            isHaveNavigation,
          }}
          setHeaderflag={setHeaderflag}
        >
        </Footer>
      </If>
    </div>
  );
}

let shankUpDownTimer = null; // footer上下抖动定时器
let shankLeftRightTimer = null; // footer左右抖动定时器
function Footer(props) {
  const { t } = useCustomTranslation();
  const jumpHistory = useHistory();
  const scrollIntoView = () => {
    const footerDoc = document.querySelector('#footer__homePage');
    const documHeight = document.documentElement.clientHeight;
    const scrollY = footerDoc?.offsetTop - footerDoc?.offsetHeight + documHeight;
    window.scrollTo(0, scrollY);
  };
  const [shankObj, setShankObj] = useState({
    backUp: '',
    search: '',
  });
  const [curFocusIdx, setCurFocusIdx] = useState(0);
  const curFocusIdxRef = useRef(curFocusIdx);
  useEffect(() => {
    curFocusIdxRef.current = curFocusIdx;
  }, [curFocusIdx]);

  const isChecked = useMemo(() => !!(props.headerflag === 8), [props.headerflag]);
  const isCheckedRef = useRef(isChecked);
  useEffect(() => {
    isCheckedRef.current = isChecked;
  }, [isChecked]);

  useEffect(() => {
    if (isChecked && !props.isLeave) {
      scrollIntoView();
    }
  }, [isChecked, props.isLeave]);

  // 五个状态，判断上下切换开始
  const isHavePosterRef = useRef(props.judgeCondition.isHavePoster);
  const isHaveHistoryRef = useRef(props.judgeCondition.isHaveHistory);
  const isHaveFilterRef = useRef(props.judgeCondition.isHaveFilter);
  const isHaveFirstColumnRef = useRef(props.judgeCondition.isHaveFirstColumn);
  const isHaveColumnRef = useRef(props.judgeCondition.isHaveColumn);
  const isHaveNavigationRef = useRef(props.judgeCondition.isHaveNavigation);

  useEffect(() => {
    isHavePosterRef.current = props.judgeCondition.isHavePoster;
  }, [props.judgeCondition.isHavePoster]);
  useEffect(() => {
    isHaveHistoryRef.current = props.judgeCondition.isHaveHistory;
  }, [props.judgeCondition.isHaveHistory]);
  useEffect(() => {
    isHaveFilterRef.current = props.judgeCondition.isHaveFilter;
  }, [props.judgeCondition.isHaveFilter]);
  useEffect(() => {
    isHaveFirstColumnRef.current = props.judgeCondition.isHaveFirstColumn;
  }, [props.judgeCondition.isHaveFirstColumn]);
  useEffect(() => {
    isHaveColumnRef.current = props.judgeCondition.isHaveColumn;
  }, [props.judgeCondition.isHaveColumn]);
  useEffect(() => {
    isHaveNavigationRef.current = props.judgeCondition.isHaveNavigation;
  }, [props.judgeCondition.isHaveNavigation]);
  // 五个状态，判断上下切换结束

  // 上下抖动
  const shankUpDown = () => {
    switch (curFocusIdxRef.current) {
      case 0:
        setShankObj({
          backUp: 'upDown',
          search: '',
        });
        break;
      case 1:
        setShankObj({
          backUp: '',
          search: 'upDown',
        });
        break;
      default:
        break;
    }
    if (shankUpDownTimer) {
      clearTimeout(shankUpDownTimer);
    }
    shankUpDownTimer = setTimeout(() => {
      setShankObj({
        backUp: '',
        search: '',
      });
      clearTimeout(shankUpDownTimer);
    }, 2000);
  };
  // 左右抖动
  const shankLeftRight = () => {
    switch (curFocusIdxRef.current) {
      case 0:
        setShankObj({
          backUp: 'leftOrRight',
          search: '',
        });
        break;
      case 1:
        setShankObj({
          backUp: '',
          search: 'leftOrRight',
        });
        break;
      default:
        break;
    }
    if (shankLeftRightTimer) {
      clearTimeout(shankLeftRightTimer);
    }
    shankLeftRightTimer = setTimeout(() => {
      setShankObj({
        backUp: '',
        search: '',
      });
      clearTimeout(shankLeftRightTimer);
    }, 2000);
  };
  // 移除抖动函数
  const removeShanke = () => {
    setShankObj({
      backUp: '',
      search: '',
    });
    clearTimeout(shankUpDownTimer);
    clearTimeout(shankLeftRightTimer);
  };

  // 左移
  const moveLeft = () => {
    if (!isCheckedRef.current) return;
    removeShanke();
    if (curFocusIdxRef.current > 0) {
      setCurFocusIdx(curFocusIdx => curFocusIdx - 1);
    } else {
      shankLeftRight();
    }
  };
  // 右移
  const moveRight = () => {
    if (!isCheckedRef.current) return;
    removeShanke();
    if (curFocusIdxRef.current < 1) {
      setCurFocusIdx(curFocusIdx => curFocusIdx + 1);
    } else {
      shankLeftRight();
    }
  };
  // 上移
  const moveUp = () => {
    if (!isCheckedRef.current) return;
    if (isHaveColumnRef.current) {
      props.setHeaderflag(7);
    } else if (isHaveFilterRef.current) {
      props.setHeaderflag(6);
    } else if (isHaveFirstColumnRef.current) {
      props.setHeaderflag(5);
    } else if (isHaveHistoryRef.current) {
      props.setHeaderflag(4);
    } else if (isHavePosterRef.current) {
      props.setHeaderflag(3);
    } else if (isHaveNavigationRef.current) {
      props.setHeaderflag(2);
    } else {
      props.setHeaderflag(1);
    }
  };
  // 下移
  const moveDown = () => {
    if (!isCheckedRef.current) return;
    shankUpDown();
  };
  // 点击
  const moveClick = () => {
    if (!isCheckedRef.current) return;
    if (curFocusIdxRef.current === 0) {
      // window.scrollTo(0, 0);
      if (isHaveNavigationRef.current) {
        props.setHeaderflag(2);
      } else {
        props.setHeaderflag(1);
      }
      Event.emit(EVENTS.HOME_PAGE_RETURN_TOP);
    } else if (curFocusIdxRef.current === 1) {
      jumpHistory.push('/search/home');
    }
  };

  useEffect(() => {
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_LEFT, moveLeft);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_RIGHT, moveRight);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_UP, moveUp);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_DOWN, moveDown);
    Event.on(EVENTS.HOME_PAGE_KEY_DOWN_CLICK, moveClick);
    return () => {
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_LEFT, moveLeft);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_RIGHT, moveRight);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_UP, moveUp);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_DOWN, moveDown);
      Event.off(EVENTS.HOME_PAGE_KEY_DOWN_CLICK, moveClick);
    };
  }, []);

  function mouseClick(e, curFocusIdx) {
    e && e.stopPropagation && e.stopPropagation();
    if (isCheckedRef.current && curFocusIdxRef.current === curFocusIdx) {
      moveClick();
      return;
    }
    setCurFocusIdx(curFocusIdx);
    curFocusIdxRef.current = curFocusIdx;
    Event.emit(EVENTS.HOME_UPDATE_STATE, {
      headerflag: 8,
    });
  }

  return (
    <div
      className='footer__homePage'
      id="footer__homePage"
    >
      <div className={curFocusIdx === 0 && isChecked ? 'select' : null}>
        <span
          className={[
            'footer__homePage__backUp',
            shankObj.backUp === 'upDown' && curFocusIdx === 0 ? 'shake1' : null,
            shankObj.backUp === 'leftOrRight' && curFocusIdx === 0 ? 'shake2' : null,
          ].join(' ')}
          onClick={e => mouseClick(e, 0)}
        >
          {' '}
          <Marquee
            children={t('回到顶部')}
            mainWidth={170}
            scrollStatus={(curFocusIdx === 0) && isChecked }
            index={1}
          />
        </span>
      </div>
      <div
        style={{ display: 'inline-block' }}
        className={curFocusIdx === 1 && isChecked ? 'select' : null}
      >
        <span
          className={[
            'footer__homePage__search',
            shankObj.search === 'upDown' ? 'shake1' : null,
            shankObj.search === 'leftOrRight' ? 'shake2' : null,
          ].join(' ')}
          onClick={e => mouseClick(e, 1)}
        >
          {t('搜索')}
        </span>
      </div>
    </div>
  );
}
